<template>
    <div class="redBook" v-if="show" @click="close">
        <!-- 挖矿规则弹窗特殊处理：背景图片中显示内容图片 -->
        <div class="content" ref="content" :class="{ 'mining-content': bookType === 'mining' }">
            <div v-if="bookType === 'mining'" class="mining-wrapper">
                <img class="mining-bg" :src="require('../assets/server/pointrule.png')" alt="beijing">
                <img class="mining-img" :src="imgUrl" alt="挖矿规则">
                <div class="close-btn" @click.stop="$emit('showReceive', false)">
                    <span class="close-icon">×</span>
                </div>
            </div>
            <img v-else :src="imgUrl" alt="">
        </div>
        <div class="page" ref="page" v-if="bookType !== 'mining'">
            <div class="pre" @click="change('pre')">←{{$t('Configuration.pages[0]')}}</div>
            <div class="next" @click="change('next')">{{$t('Configuration.pages[1]')}}→</div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'RedBook',
  components: {},
  props: {
    show: {
        type: Boolean,
        default: false,
    },
    bookType: {
        type: String,
        default: 'red' // 'red'、'white' 或 'mining'
    }
  },
  // 监听选项，与props同级
  watch: {
    // 监听bookType变化，重置页码并加载对应书籍的首页
    bookType: {
        handler(newType) {
            this.page = 1
            if (newType === 'red') {
                this.imgUrl = require('../assets/develop/redbook/1.jpg')
            } else if (newType === 'white') {
                this.imgUrl = require('../assets/develop/white/BIT_white01.jpg')
            } else if (newType === 'mining') {
                this.imgUrl = require('../assets/server/minerule.jpg')
            }
        },
        immediate: true
    },
    // 监听show属性变化，当弹窗关闭时重置页码
    show(newVal) {
        if (!newVal) {
            // 弹窗关闭时，重置页码为1
            this.page = 1
            // 重置图片URL为首页
            if (this.bookType === 'red') {
                this.imgUrl = require('../assets/develop/redbook/1.jpg')
            } else if (this.bookType === 'white') {
                this.imgUrl = require('../assets/develop/white/BIT_white01.jpg')
            } else if (this.bookType === 'mining') {
                this.imgUrl = require('../assets/server/minerule.jpg')
            }
        }
    }
  },
  data() {
    return {
        page: 1,
        // 初始化时直接设置默认图片，避免空白显示
        imgUrl: require('../assets/develop/redbook/1.jpg'),
    }
  },
  // 添加created钩子，确保组件创建时正确设置初始图片
  created() {
    this.page = 1
    if (this.bookType === 'red') {
      this.imgUrl = require('../assets/develop/redbook/1.jpg')
    } else if (this.bookType === 'white') {
      this.imgUrl = require('../assets/develop/white/BIT_white01.jpg')
    } else if (this.bookType === 'mining') {
      this.imgUrl = require('../assets/server/minerule.jpg')
    }
  },
  methods: {
    change(type) {
        let page = this.page
        if(type === 'pre') {
            page -= 1
        } else {
            page += 1
        }

        // 根据书籍类型设置不同的总页数和图片路径
        const totalPages = this.bookType === 'red' ? 47 : this.bookType === 'white' ? 38 : 1
        
        if(page <= 0) {
            page = 1
        }

        if(page > totalPages) {
            page = totalPages
        }

        this.page = page
        
        if (this.bookType === 'red') {
            this.imgUrl = require('../assets/develop/redbook/'+page+'.jpg')
        } else if (this.bookType === 'white') {
            // 白皮书文件名格式需要两位数
            const formattedPage = page.toString().padStart(2, '0')
            this.imgUrl = require(`../assets/develop/white/BIT_white${formattedPage}.jpg`)
        } else if (this.bookType === 'mining') {
            this.imgUrl = require('../assets/server/minerule.jpg')
        }
    },
    close(event) {
        // 对于挖矿规则弹窗，直接检查是否点击了内容区域外部
        if (this.bookType === 'mining') {
            if (!this.$refs.content.contains(event.target)) {
                this.$emit('showReceive', false)
            }
        } else {
            // 对于普通弹窗，检查是否点击了内容区域和页码区域外部
            if (!this.$refs.content.contains(event.target) && !this.$refs.page.contains(event.target)) {
                this.$emit('showReceive', false)
            }
        }
    },
  },
}
</script>

<style lang="scss" scoped>
.redBook {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000;

    .content {
        // width: 60%;
        // max-width: 800px;
        // height: 80%;
        max-height: 600px;
        border: 20px solid #000;
        border-radius: 15px;
        background-color: #000;
        margin: 0 auto;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
        
        img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            object-fit: contain;
        }
    }
    
    // 挖矿规则弹窗特殊样式
    .mining-content {
            position: relative;
            max-height: 700px;
            max-width: 900px;
            border: none;
            background: none;
            
            .mining-wrapper {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            
            .mining-bg {
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: contain;
                z-index: 1;
            }
            
            .mining-img {
                position: relative;
                width: 81%;
                height: 90%;
                object-fit: contain;
                z-index: 2;
            }
            
            .close-btn {
                position: absolute;
                top: -40px;
                right: 0;
                width: 40px;
                height: 40px;
                background-color: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                z-index: 3;
                transition: all 0.3s ease;
                
                &:hover {
                    background-color: rgba(255, 255, 255, 0.3);
                    transform: scale(1.1);
                }
                
                .close-icon {
                    color: white;
                    font-size: 24px;
                    font-weight: bold;
                    line-height: 1;
                }
            }
        }

    .page {
        display: flex;
        justify-content: space-between;
        width: 60%;
        max-width: 800px;
        margin: 30px auto;
        font-size: 18px;
        color: #fff;
        
        .pre {
            padding: 10px 20px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 25px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-weight: 600;

            &:hover {
                background: rgba(255, 255, 255, 0.3);
                transform: translateY(-2px);
            }
        }
        
        .next {
            padding: 10px 20px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 25px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-weight: 600;

            &:hover {
                background: rgba(255, 255, 255, 0.3);
                transform: translateY(-2px);
            }
        }
    }
}


@media (max-width: 768px) {
    .redBook {
        .content {
            width: 90%;
            height: 70%;
            border: 15px solid #000;
        }

        .page {
            width: 90%;
            margin: 20px auto;
            font-size: 16px;

            .pre, .next {
                padding: 8px 16px;
            }
        }
    }
}
</style>